export default __webpack_public_path__ + "./assets/logo-white__f8855fc4eae9053ddb5eb2f8d67a74b1.png";